import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { isMobileUa } from '../../shared/features/uatraits';
import { CONFERENCE_HISTORY_PAGE_ID } from './constants';

const CONFERENCES_HISTORY_MIN_WIDTH = 880;

export const useIsMobileOneColLayout = () => {
    const isMobile = useSelector(isMobileUa);
    return isMobile;
};

export const useIsDesktopOneColLayout = (): boolean => {
    const [isNarrow, setIsNarrow] = useState(false);
    const isMobile = useIsMobileOneColLayout();

    useEffect(() => {
        const element = document.getElementById(CONFERENCE_HISTORY_PAGE_ID);

        if (!element) {
            return;
        }

        setIsNarrow(element.getBoundingClientRect().width <= CONFERENCES_HISTORY_MIN_WIDTH);

        const observer = new ResizeObserver(([entry]) => {
            setIsNarrow(entry.contentRect.width <= CONFERENCES_HISTORY_MIN_WIDTH);
        });

        observer.observe(element);

        return () => observer.disconnect();
    }, []);

    return isNarrow && !isMobile;
};

export const useIsOneColLayout = (): boolean => {
    const isMobile = useIsMobileOneColLayout();
    const isDesktop = useIsDesktopOneColLayout();

    return isMobile || isDesktop;
};
